import { Link } from "react-router-dom";
import grupoBcLogo from "@/assets/clients/grupo-bc-energia.png";
import flexEnergyLogo from "@/assets/clients/flex-energy.png";
import fcgLogo from "@/assets/clients/fcg-participacoes.png";
import economiaNaEnergiaLogo from "@/assets/clients/economia-na-energia.png";
import nossaEnergiaLogo from "@/assets/clients/nossa-energia.png";
import clientFcg from "@/assets/clients/logo-fcg.jpg";
import clientFlexEnergy from "@/assets/clients/logo-flex-energy.png";
import clientBcEnergia from "@/assets/clients/logo-bc-energia.png";
import clientNossaEnergia from "@/assets/clients/logo-nossa-energia.png";
import clientFsolar from "@/assets/clients/logo-fsolar.png";
import clientViia from "@/assets/clients/logo-viia.png";
import clientSolaris from "@/assets/clients/logo-solaris.jpeg";
import clientMgs from "@/assets/clients/logo-mgs-energia.png";
import clientStonos from "@/assets/clients/logo-stonos.png";
import clientNitia from "@/assets/clients/logo-nitia.png";
import dist01 from "@/assets/distribuidoras/dist-01.png";
import dist02 from "@/assets/distribuidoras/dist-02.png";
import dist03 from "@/assets/distribuidoras/dist-03.png";
import dist04 from "@/assets/distribuidoras/dist-04.png";
import dist05 from "@/assets/distribuidoras/dist-05.png";
import dist06 from "@/assets/distribuidoras/dist-06.png";
import dist07 from "@/assets/distribuidoras/dist-07.png";
import dist08 from "@/assets/distribuidoras/dist-08.png";
import dist09 from "@/assets/distribuidoras/dist-09.png";
import dist10 from "@/assets/distribuidoras/dist-10.png";
import dist11 from "@/assets/distribuidoras/dist-11.png";
import dist12 from "@/assets/distribuidoras/dist-12.png";
import coverageMap from "@/assets/mapa-cobertura-brasil.png";
import iconOperacional from "@/assets/icon-operacional.png";
import iconConfiabilidade from "@/assets/icon-confiabilidade.png";
import iconVisao from "@/assets/icon-visao.png";
import {
  ArrowRight,
  FileText,
  Calculator,
  CreditCard,
  Users,
  Shield,
  AlertTriangle,
  FileSpreadsheet,
  Building2,
  Handshake,
  Store,
  Briefcase,
  Plug,
  Wallet,
  MessageSquare,
  Database,
  CheckCircle2,
  Activity,
  TrendingUp,
  Bot,
  Clock,
  Search,
  Eye,
  BarChart3,
  Zap,
  FileCheck,
  CircleDollarSign,
  ClipboardCheck,
  Send as SendIcon,
  MapPin,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Layout } from "@/components/layout/Layout";
import { FAQ } from "@/components/shared/FAQ";
import { LeadForm } from "@/components/shared/LeadForm";

// ─── PARA QUEM É ───
const personas = [
  {
    icon: Building2,
    title: "Gerador",
    description:
      "Controle a distribuição de créditos, automatize cobranças e tenha visibilidade real sobre saldo e inadimplência de cada UC.",
  },
  {
    icon: Handshake,
    title: "Consórcio / Cooperativa / Associação",
    description:
      "Parametrize regras de aluguel para suas unidades consumidoras, garanta rastreabilidade nas cobranças e elimine conflitos por falta de transparência.",
  },
  {
    icon: Store,
    title: "Comercializadora",
    description:
      "Escale a carteira sem multiplicar equipe. Centralize faturas, auditoria e cobranças em um único fluxo automatizado.",
  },
  {
    icon: Briefcase,
    title: "Backoffice / Operação",
    description:
      "Substitua planilhas por processos parametrizados. Menos conferência manual, mais confiabilidade no fechamento mensal.",
  },
];

// ─── O PROBLEMA ───
const problemItems = [
  {
    icon: FileSpreadsheet,
    text: "Faturas espalhadas e processamento manual",
  },
  {
    icon: AlertTriangle,
    text: "Erros de saldo, injeção ou compensação detectados tarde",
  },
  {
    icon: Calculator,
    text: "Cobrança e rateio dependentes de planilha",
  },
  {
    icon: Eye,
    text: "Pouca clareza sobre o que foi cobrado e por quê",
  },
  {
    icon: Clock,
    text: "Fechamento mensal travado por gargalos operacionais",
  },
  {
    icon: TrendingUp,
    text: "Crescimento da carteira exigindo mais pessoas, não mais eficiência",
  },
];

// ─── VALOR EM 3 DIMENSÕES ───
const valueDimensions = [
  {
    image: iconOperacional,
    title: "Operação",
    description:
      "Coleta automatizada de faturas, processamento centralizado e cálculo parametrizado de cobranças — sem depender de controles paralelos.",
  },
  {
    image: iconConfiabilidade,
    title: "Confiabilidade e controle",
    description:
      "Auditoria automática de dados da concessionária, rastreabilidade completa de ações e detecção de divergências antes que impactem o faturamento.",
  },
  {
    image: iconVisao,
    title: "Visão gerencial e financeira",
    description:
      "Acompanhamento de saldo, inadimplência, desempenho da carteira e saúde financeira da operação em tempo real.",
  },
];

// ─── MÓDULOS DA SOLUÇÃO ───
const solutionModules = [
  {
    icon: Bot,
    title: "Automação de faturas",
    badge: "Automático",
    description:
      "Automações e IA para coleta e processamento de faturas via e-mail ou portal da distribuidora. Status de cada fatura visível a todo momento.",
  },
  {
    icon: Calculator,
    title: "Regras de aluguel e cálculo",
    badge: "Parametrizável",
    description:
      "Dezenas de regras de aluguel pré-cadastradas. Suas regras de negócio transformadas em cálculos automáticos e auditáveis.",
  },
  {
    icon: FileCheck,
    title: "Auditoria de faturas",
    badge: "Validação automática",
    description:
      "Comparação de saldo, injeção e compensado com destaque claro de divergências. Validação automática dos dados da concessionária.",
  },
  {
    icon: ClipboardCheck,
    title: "Gestão do ciclo de faturamento",
    badge: "Fluxo completo",
    description:
      "Da coleta à emissão de boletos em um fluxo único. Revisão, aprovação e acompanhamento de cada etapa do fechamento.",
  },
  {
    icon: CircleDollarSign,
    title: "Cobrança e gestão financeira",
    badge: "Régua automatizada",
    description:
      "Emissão de boletos, régua de cobrança automatizada, prorrogação, baixa, extras e descontos. Previsibilidade sobre recebimentos.",
  },
  {
    icon: Activity,
    title: "Inteligência de saldo e carteira",
    badge: "Indicadores ISC/ICC",
    description:
      "Saldo de crédito, consumo compensado, inadimplência e histórico. Portal para investidores com indicadores de rendimento.",
  },
];

// ─── CICLO DE FATURAMENTO ───
const cycleSteps = [
  {
    step: 1,
    title: "Coleta de faturas",
    description:
      "Robôs coletam faturas das distribuidoras automaticamente via portal, e-mail ou upload manual.",
  },
  {
    step: 2,
    title: "Extração e auditoria",
    description:
      "Dados extraídos passam por auditoria automática: saldo, injeção, compensado e valores conferidos.",
  },
  {
    step: 3,
    title: "Cálculo das cobranças",
    description:
      "Cobranças calculadas conforme regras de aluguel parametrizadas — sem intervenção manual.",
  },
  {
    step: 4,
    title: "Revisão e aprovação",
    description:
      "Equipe revisa e aprova pré-faturas antes da emissão. Tudo rastreável.",
  },
  {
    step: 5,
    title: "Emissão e cobrança",
    description:
      "Boletos emitidos e enviados automaticamente. Régua de cobrança ativada.",
  },
];

// ─── BANCOS ───
import logoAsaas from "@/assets/banks/logo-asaas.png";
import logoBB from "@/assets/banks/logo-banco-do-brasil.png";
import logoCora from "@/assets/banks/logo-cora.png";
import logoInter from "@/assets/banks/logo-inter.png";
import logoSantander from "@/assets/banks/logo-santander.png";
import logoItau from "@/assets/banks/logo-itau.png";
import logoSicredi from "@/assets/banks/logo-sicredi.png";
import logoSicoob from "@/assets/banks/logo-sicoob.png";
import { SEO } from "@/components/seo/SEO";

const homologatedBanks = [
  { name: "ASAAS", logo: logoAsaas },
  { name: "Banco do Brasil", logo: logoBB },
  { name: "Cora", logo: logoCora },
  { name: "Inter", logo: logoInter },
  { name: "Santander", logo: logoSantander },
  { name: "Itaú", logo: logoItau },
  { name: "Sicredi", logo: logoSicredi },
  { name: "Sicoob", logo: logoSicoob },
];

// ─── INTEGRAÇÕES ───
const integrations = [
  {
    icon: Building2,
    title: "Distribuidoras",
    description: "Robôs de download em 19 estados",
  },
  {
    icon: Wallet,
    title: "Bancos",
    description: "8 bancos homologados para boletos",
  },
  {
    icon: MessageSquare,
    title: "WhatsApp e E-mail",
    description: "Notificações e cobranças automatizadas",
  },
  {
    icon: Database,
    title: "ERP e CRM",
    description: "API aberta para integração",
  },
];

// ─── DISTRIBUIDORAS ───
const distribuidoraLogos = [
  dist01, dist02, dist03, dist04, dist05, dist06,
  dist07, dist08, dist09, dist10, dist11, dist12,
];

// ─── FAQ ───
const faqItems = [
  {
    question: "A Cogni atende geração compartilhada e autoconsumo remoto?",
    answer:
      "Sim. A plataforma suporta ambos os modelos previstos na Lei 14.300 — geração compartilhada (consórcios, cooperativas) e autoconsumo remoto — com parametrização de regras de aluguel, rateio e cobrança específicas para cada cenário.",
  },
  {
    question: "Quais etapas da operação a plataforma cobre?",
    answer:
      "A Cogni cobre o ciclo completo: coleta e processamento de faturas, auditoria de dados da concessionária, parametrização de regras de aluguel, cálculo das cobranças, emissão de boletos, régua de cobrança automatizada, gestão financeira e inteligência de saldo da carteira.",
  },
  {
    question: "É possível parametrizar regras de aluguel?",
    answer:
      "Sim. A plataforma oferece dezenas de regras de aluguel pré-cadastradas e te dá flexibilidade para configurar regras por UC e por período específico, considerando os variados cenários possíveis de descontos para GDI, GDII, bandeiras e tarifas.",
  },
  {
    question: "A Cogni integra com bancos e ERP?",
    answer:
      "Sim. Temos 8 bancos homologados para emissão de boletos registrados (ASAAS, BB, Cora, Inter, Santander, Itaú, Sicredi, Sicoob) e API aberta para integração com ERPs, CRMs e sistemas internos.",
  },
  {
    question: "Como funciona o processamento e auditoria de faturas?",
    answer:
      "Robôs coletam faturas automaticamente nos portais das distribuidoras ou via e-mail. Os dados são extraídos por IA e passam por auditoria automática: saldo, injeção, compensado e valores são conferidos com destaque claro de divergências para ação rápida.",
  },
  {
    question: "A plataforma atende múltiplas distribuidoras?",
    answer:
      "Sim. Temos robôs de download e leitura nas principais distribuidoras do Brasil: Energisa, ENEL, Equatorial, CEMIG, Neoenergia, EDP, Light, Celesc, RGE, CEEE e CPFL Energia. ",
  },
];

const Index = () => {
  return (
    <Layout>
      <SEO path="/" title="Cogni — Gestão de Créditos de Energia GD" description="Plataforma completa para gestão de créditos de geração distribuída: rateio automático, faturamento, conciliação bancária e portal do consumidor." />
      {/* ═══ HERO ═══ */}
      <section className="relative overflow-hidden py-14 sm:py-20 md:py-28">
        <div className="absolute inset-0 gradient-hero" />
        <div className="absolute top-0 right-0 w-[300px] sm:w-[400px] lg:w-[600px] h-[300px] sm:h-[400px] lg:h-[600px] blob-gradient opacity-60" />
        <div className="absolute bottom-0 left-0 w-[200px] sm:w-[300px] lg:w-[400px] h-[200px] sm:h-[300px] lg:h-[400px] blob-purple opacity-40" />

        <div className="container-wide relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-display font-bold mb-4 sm:mb-6 text-balance leading-tight">
              Sua operação de créditos de energia cresceu.{" "}
              <span className="text-gradient">O risco operacional também.</span>
            </h1>
            <p className="text-body-lg text-muted-foreground mb-6 sm:mb-8 max-w-3xl mx-auto">
              A Cogni centraliza o processamento de faturas, auditoria, regras de aluguel, cálculo das cobranças, emissão de boletos, régua de cobrança, inteligência de saldo e acompanhamento da carteira em uma plataforma feita para operações de geração distribuída com complexidade real.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-4">
              <Link to="/contato" className="w-full sm:w-auto">
                <Button
                  size="lg"
                  className="w-full sm:w-auto gradient-primary text-primary-foreground px-8 glow-primary touch-target text-base"
                >
                  Agendar demonstração da plataforma
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </div>

            {/* Microcopy */}
            <p className="text-xs sm:text-sm text-muted-foreground/70 mb-0">
              Demonstração orientada ao seu modelo operacional
            </p>
          </div>
        </div>
      </section>

      {/* ═══ BARRA DE CREDIBILIDADE ═══ */}
      <section className="credibility-bar py-6 sm:py-8 border-b border-white/10">
        <div className="container-wide">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 mb-6 sm:mb-8">
            {[
              { value: "35.000+", label: "faturas processadas/mês" },
              { value: "19", label: "estados com robôs de coleta e leitura de fatura" },
              { value: "12+", label: "anos de experiência no mercado de energia" },
              { value: "8", label: "bancos homologados" },
            ].map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-1">
                  {stat.value}
                </div>
                <div className="text-xs sm:text-sm text-white/60">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ PARA QUEM É ═══ */}
      <section id="clientes" className="section-padding bg-background">
        <div className="container-wide">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-headline font-bold mb-4">
              Feita para operações que já sentiram o limite do controle manual
            </h2>
            <p className="text-body-lg text-muted-foreground max-w-2xl mx-auto">
              Se sua operação já passou do ponto em que planilhas, e-mails e controles paralelos dão conta, a Cogni foi construída para o seu cenário.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {personas.map((persona, index) => (
              <div
                key={index}
                className="card-highlight border rounded-xl p-5 sm:p-6 text-center hover:shadow-xl transition-all group"
              >
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-gradient-to-br from-cogni-teal/20 to-cogni-blue/10 mx-auto flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 transition-transform">
                  <persona.icon className="h-6 w-6 sm:h-7 sm:w-7 text-cogni-teal" />
                </div>
                <h3 className="font-semibold text-lg sm:text-base mb-2">{persona.title}</h3>
                <p className="text-muted-foreground text-xs sm:text-sm leading-relaxed">
                  {persona.description}
                </p>
              </div>
            ))}
          </div>

          {/* Client logos marquee */}
          <div className="mt-10 sm:mt-14 overflow-hidden">
            <p className="text-center text-xs sm:text-sm text-muted-foreground mb-5">
              Empresas que confiam na Cogni
            </p>
            <div className="relative">
              <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-background to-transparent z-10" />
              <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-background to-transparent z-10" />
              <div className="flex animate-marquee whitespace-nowrap">
                {[clientFcg, clientFlexEnergy, clientBcEnergia, clientNossaEnergia, clientFsolar, clientViia, clientSolaris, clientMgs, clientStonos, clientNitia,
                  clientFcg, clientFlexEnergy, clientBcEnergia, clientNossaEnergia, clientFsolar, clientViia, clientSolaris, clientMgs, clientStonos, clientNitia].map((logo, i) => (
                  <div key={i} className="inline-flex items-center justify-center mx-6 sm:mx-8 flex-shrink-0">
                    <img src={logo} alt="Cliente Cogni" className="h-10 sm:h-12 w-auto object-contain max-w-[140px] sm:max-w-[160px]" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══ O PROBLEMA ═══ */}
      <section className="section-padding section-warm">
        <div className="container-wide">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-headline font-bold mb-4">
              O problema não é só operacional. É financeiro.
            </h2>
            <p className="text-body-lg text-muted-foreground max-w-3xl mx-auto">
              Quando a operação roda em planilhas, e-mails, downloads manuais e controles paralelos, a equipe passa a compensar falhas de processo com esforço humano. O custo aparece em conferência manual, retrabalho, inconsistências, atraso no fechamento, baixa rastreabilidade e risco direto sobre faturamento, cobrança e saldo da carteira.
            </p>
          </div>
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
              {problemItems.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 bg-background border-2 border-destructive/20 rounded-xl p-4 sm:p-5 hover:border-destructive/40 transition-colors shadow-sm"
                >
                  <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-destructive/20 to-destructive/5 flex items-center justify-center flex-shrink-0">
                    <item.icon className="h-5 w-5 text-destructive" />
                  </div>
                  <p className="text-sm sm:text-base font-medium">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ═══ VALOR EM 3 DIMENSÕES ═══ */}
      <section className="section-padding section-gradient-blue relative overflow-hidden">
        <div className="absolute top-20 left-10 w-[200px] sm:w-[300px] h-[200px] sm:h-[300px] blob-gradient opacity-30" />
        <div className="container-wide relative z-10">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-headline font-bold mb-4">
              Sua transformação com a Cogni
            </h2>
            <p className="text-body-lg text-muted-foreground max-w-2xl mx-auto">
              Saia de uma operação fragmentada e artesanal para uma centralizada, padronizada e altamente eficiente.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 max-w-5xl mx-auto">
            {valueDimensions.map((dim, index) => (
              <div
                key={index}
                className="border border-border rounded-xl p-6 sm:p-8 text-center hover:shadow-xl hover:border-primary/40 transition-all group bg-white"
              >
                <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 group-hover:scale-110 transition-transform">
                  <img src={dim.image} alt={dim.title} className="w-full h-full object-contain" />
                </div>
                <h3 className="text-lg sm:text-xl font-bold mb-2">{dim.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{dim.description}</p>
              </div>
            ))}
          </div>
          <p className="text-center text-muted-foreground mt-6 sm:mt-8 text-sm sm:text-base max-w-2xl mx-auto">
            Na prática: uma operação{" "}
            <strong className="text-foreground">
              menos artesanal, mais previsível
            </strong>{" "}
            e preparada para crescer sem multiplicar equipe.
          </p>
        </div>
      </section>

      {/* ═══ COGNI: A CAMADA DE CONTROLE ═══ */}
      <section id="como-funciona" className="section-padding relative overflow-hidden">
        <div className="container-wide relative z-10">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-headline font-bold mb-4">
              A Cogni é a camada de controle da sua operação
            </h2>
            <p className="text-body-lg text-muted-foreground max-w-3xl mx-auto mb-3">
              Estruturamos o núcleo operacional e financeiro da gestão de créditos de energia: da coleta e processamento de faturas, até a inteligência de saldo e acompanhamento da carteira.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {solutionModules.map((module, index) => (
              <div
                key={index}
                className="card-gradient border border-border rounded-xl p-5 sm:p-6 hover:shadow-xl hover:border-primary/40 transition-all group"
              >
                <div className="mb-4">
                  <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-lg bg-gradient-to-br from-primary/20 to-cogni-blue/10 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <module.icon className="h-5 w-5 sm:h-6 sm:w-6 text-primary" />
                  </div>
                </div>
                <h3 className="text-lg sm:text-lg font-semibold mb-2">{module.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {module.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ CICLO DE FATURAMENTO ═══ */}
      <section className="section-padding section-dark">
        <div className="container-wide">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-headline font-bold mb-4 text-white">
              Do recebimento da fatura ao recebimento da cobrança
            </h2>
            <p className="text-body-lg text-white/70 max-w-2xl mx-auto">
              Cinco etapas. Um fluxo. Controle de ponta a ponta.
            </p>
          </div>
          <div className="max-w-3xl mx-auto">
            <div className="timeline-container space-y-0">
              {cycleSteps.map((item, index) => (
                <div key={index} className="flex gap-4 sm:gap-6 group relative">
                  {/* Timeline line */}
                  <div className="flex flex-col items-center flex-shrink-0">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full gradient-vibrant text-white flex items-center justify-center font-bold text-base sm:text-lg shadow-lg glow-accent relative z-10">
                      {item.step}
                    </div>
                    {index < cycleSteps.length - 1 && (
                      <div className="w-0.5 flex-1 bg-gradient-to-b from-cogni-blue/40 to-cogni-violet/20 my-1" />
                    )}
                  </div>
                  <div className="flex-1 pb-6 sm:pb-8">
                    <h3 className="text-lg sm:text-lg font-semibold mb-1 text-white">
                      {item.title}
                    </h3>
                    <p className="text-white/60 text-sm">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Bancos homologados */}
          <div className="mt-10 sm:mt-14 max-w-3xl mx-auto text-center">
            <p className="text-white/50 text-xs sm:text-sm mb-4">
              Bancos homologados para emissão de boletos
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
              {homologatedBanks.map((bank, i) => (
                <img
                  key={i}
                  src={bank.logo}
                  alt={bank.name}
                  className="h-6 sm:h-8 object-contain opacity-80 hover:opacity-100 transition-opacity"
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ═══ PROVA SOCIAL ═══ */}
      <section id="atuacao" className="section-padding bg-white">
        <div className="container-wide">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-headline font-bold mb-4">
              Operações que precisam de controle escolhem a Cogni
            </h2>
          </div>

          {/* Mapa + números + distribuidoras */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 max-w-5xl mx-auto">
            <div className="flex items-center justify-center">
              <img
                src={coverageMap}
                alt="Mapa de atuação da Cogni em 19 estados do Brasil"
                className="w-full max-w-sm object-contain"
              />
            </div>
            <div className="flex flex-col justify-center">
              <div className="space-y-6 mb-8">
                <div>
                  <div className="text-3xl sm:text-4xl font-bold text-primary mb-1">19 estados</div>
                  <p className="text-muted-foreground text-sm">
                    com robôs de coleta automática de faturas em distribuidoras
                  </p>
                </div>
                <div>
                  <div className="text-3xl sm:text-4xl font-bold text-primary mb-1">30.000+</div>
                  <p className="text-muted-foreground text-sm">
                    faturas processadas mensalmente na plataforma
                  </p>
                </div>
                <div>
                  <div className="text-3xl sm:text-4xl font-bold text-primary mb-1">12+ anos</div>
                  <p className="text-muted-foreground text-sm">
                    de experiência no mercado de energia e GD
                  </p>
                </div>
              </div>
              {/* Distribuidoras ao lado do mapa */}
              <div>
                <p className="text-xs sm:text-sm text-muted-foreground mb-3">
                  Distribuidoras atendidas
                </p>
                <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 sm:gap-4">
                  {distribuidoraLogos.map((logo, i) => (
                    <div key={i} className="h-8 sm:h-10 flex items-center justify-center">
                      <img
                        src={logo}
                        alt="Logo distribuidora"
                        className="h-full w-auto object-contain opacity-70 hover:opacity-100 transition-opacity"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* ═══ FAQ ═══ */}
      <FAQ
        items={faqItems}
        title="Perguntas frequentes"
        subtitle="Dúvidas sobre a plataforma, cobertura e funcionalidades"
      />

      {/* ═══ CTA FINAL ═══ */}
      <section id="agendar-demo" className="section-padding relative overflow-hidden">
        <div className="absolute inset-0 gradient-hero-dark" />
        <div className="absolute top-0 right-0 w-[300px] sm:w-[500px] h-[300px] sm:h-[500px] blob-gradient opacity-20" />
        <div className="absolute bottom-0 left-0 w-[250px] sm:w-[400px] h-[250px] sm:h-[400px] blob-purple opacity-20" />

        <div className="container-narrow relative z-10">
          <div className="text-center mb-8 sm:mb-10">
            <h2 className="text-headline font-bold mb-4 text-white">
              Veja como a Cogni se adapta à sua operação de gestão de créditos
            </h2>
            <p className="text-body-lg text-white/70 max-w-2xl mx-auto">
              Agende uma demonstração e entenda como centralizar faturas, auditoria, cobranças e saldo da carteira em um fluxo mais governável.
            </p>
          </div>

          <div className="max-w-xl mx-auto bg-background rounded-2xl p-5 sm:p-6 md:p-8 shadow-2xl border border-white/10">
            <LeadForm
              title="Quero ver a Cogni na minha operação"
              description="Preencha o formulário para receber uma demonstração orientada à sua operação."
            />
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Index;
